<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('SeaExport.CustomsDeclarationInfo')"
    width="500px"
    :close-on-click-modal="false"
    :append-to-body="true"
  >
    <el-form :label-width="(closeXhqCustoms) ? '65px' : '85px'" label-position="left">
      <el-form-item v-show="closeXhqCustoms" :label="$t('SeaExport.SequenceNumber')">
        <el-input v-model="oneFormData.level" style="width:50%" no="1" />
      </el-form-item>

      <el-form-item v-show="closeXhqCustoms" :label="$t('SeaExport.TenBitCode')" class="custom">
        <el-select
          ref="tenDigitCode"
          :value="oneFormData.tenDigitCode"
          filterable
          clearable
          :allow-create="true"
          style="width: 150px;"
          no="2"
          @input="tenDigitCodeChangeHandler"
          @blur="tenDigitCodeFocusOutHandler"
        >
          <el-option
            v-for="(item,index) in bussinessList"
            :key="index"
            :label="item.tenDigitCode"
            :value="item.tenDigitCode"
          />
        </el-select>
        <!--<el-input v-model="oneFormData.tenDigitCode" style="width:150px" maxlength="10" @change="tenDigitCodeChangeHandler" />-->
      </el-form-item>
      <el-form-item v-show="closeXhqCustoms && !isSalesForSzfs" :label="$t('SeaExport.OperatingCompany')" class="custom">
        <el-select
          ref="companyCname"
          :value="oneFormData.companyCname"
          filterable
          clearable
          :allow-create="true"
          style="width: 250px;"
          no="3"
          @input="queryBusinessHandler"
          @blur="companyCnameFocusOutHandler"
        >
          <el-option
            v-for="(item,index) in bussinessList"
            :key="index"
            :label="item.companyCname"
            :value="item.companyCname"
          />
        </el-select>
        <!--<el-input v-model="oneFormData.companyCname" style="width:250px" @change="queryBusinessHandler" />-->
      </el-form-item>
      <el-form-item v-show="closeXhqCustoms" :label="$t('SeaExport.BusinessNo')">
        <el-input v-model="job.jobNo" :disabled="true" no="4" />
      </el-form-item>
      <el-form-item v-show="!closeXhqCustoms" :label="$t('SeaExport.CBANumber')">
        <el-input v-model="oneFormData.cbaNumber" :disabled="true" no="4" />
      </el-form-item>
      <!--同时开启【信号旗】【关单多票模式】-->
      <el-form-item v-if="soNoFromCustomsDeclaration" :label="$t('SeaExport.SoNo')">
        <el-select v-model="oneFormData.poItemsUuid" no="soNo" clearable @change="poItemsUuidChangeHandler">
          <el-option
            v-for="item in poItems"
            :key="item.uuid"
            :label="(item.soNo ? item.soNo : $t('CargoMsg.Cargo_Empty2')) + '    ' + $t('CargoMsg.Cargo_QuantityWeightCubage') + ' : '
              + item.quantity + '/' + item.grossWeight + '/' + item.cubage"
            :value="item.uuid"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-else :label="$t('SeaExport.SoNo')">
        <el-select v-if="job.booking" v-model="oneFormData.soNo" :disabled="!isExport" no="5" :clearable="!closeXhqCustoms">
          <el-option v-for="(value) in soNoList" :key="value" :label="value" :value="value" />
        </el-select>
        <el-input v-if="!job.booking" v-model="oneFormData.soNo" />
      </el-form-item>
      <!--同时开启【信号旗】【关单多票模式】-->
      <div v-if="soNoFromCustomsDeclaration" style="margin-bottom: 10px;margin-left: 8px">
        <label style="margin-right: 4px">{{ $t('SeaExport.Quantity') }}</label>
        <el-input v-model="oneFormData.quantityActual" disabled type="number" no="quantityActual2" style="width: 80px" />
        <label style="margin-left: 10px;margin-right: 4px">{{ $t('SeaExport.WeightKg') }}</label>
        <el-input v-model="oneFormData.weightActual" disabled type="number" no="weightActual2" style="width: 80px" />
        <label style="margin-left: 10px;margin-right: 4px">{{ $t('SeaExport.CubageCbm') }}</label>
        <el-input v-model="oneFormData.cubageActual" disabled type="number" no="cubageActual2" style="width: 80px" />
      </div>
      <el-form-item v-show="closeXhqCustoms" :label="$t('CargoMsg.Cargo_CustomsDeclarationNo')">
        <el-input v-model="oneFormData.customsDeclarationNo" />
      </el-form-item>
      <el-form-item v-show="closeXhqCustoms" :label="$t('SeaExport.CustomsNo')">
        <el-input v-model="oneFormData.customsNo" no="6" />
      </el-form-item>

      <el-form-item v-show="!isSalesForSzfs" :label="$t('SeaExport.CustomsBroker')" class="custom">
        <cargo-company-select
          :method-params="{customsBroker:true,active:true}"
          :default-value="oneFormData.customsBroker||''"
          style="width:250px;"
          no="7"
          @change="p=>{oneFormData.customsBroker=p.value || 0}"
        />
        <!-- <cargo-advance-select
          :select-type="selectTypeNames.basic_data_Company"
          :method-params="{officeId:$store.getters.currentOfficeId,customsBroker:true}"
          filterable
          :default-value="oneFormData.customsBroker||''"
          tag-value="cmpIdx"
          style="width:150px;"
          @parentCallBack="p=>oneFormData.customsBroker=p.value"
        />-->
      </el-form-item>
      <el-form-item v-show="closeXhqCustoms" :label="$t('SeaExport.DateOfCustomsDeclaration')">
        <el-date-picker
          v-model="oneFormData.customsDate"
          style="width:150px"
          :editable="false"
          :clearable="false"
          type="date"
          value-format="yyyy-MM-dd"
          no="8"
        />
      </el-form-item>
      <el-form-item v-show="!closeXhqCustoms" :label="$t('CargoMsg.CustomsDeclareTime')">
        <el-date-picker
          v-model="oneFormData.declareTime"
          no="declareTime"
          style="width:150px"
          :editable="false"
          :clearable="false"
          type="datetime"
          value-format="yyyy-MM-dd HH:mm:ss"
          format="yyyy-MM-dd HH:mm:ss"
        />
      </el-form-item>
      <el-form-item v-show="!closeXhqCustoms" :label="$t('CargoMsg.NoticeBgh')">
        <el-select v-model="oneFormData.noticeBgh" no="noticeBgh" style="width:150px">
          <el-option label="Y" :value="true" />
          <el-option label="N" :value="false" />
        </el-select>
      </el-form-item>
      <el-form-item v-show="!closeXhqCustoms" :label="$t('CargoMsg.VerificationSheetRequired')">
        <el-select v-model="oneFormData.verificationSheetRequired" no="verificationSheetRequired" style="width:150px">
          <el-option label="Y" :value="true" />
          <el-option label="N" :value="false" />
        </el-select>
      </el-form-item>
      <el-form-item v-show="closeXhqCustoms" :label="$t('SeaExport.StatusOfCustomsDeclaration')" class="custom">
        <el-select v-model="oneFormData.declareCustomsState" style="width:150px" no="9">
          <el-option :label="$t('SeaExport.PleaseSelect')" :value="0" />
          <el-option :label="$t('SeaExport.Recorded')" :value="1" />
          <el-option :label="$t('SeaExport.ListPulled')" :value="2" />
          <el-option :label="$t('SeaExport.AtReception')" :value="3" />
          <el-option :label="$t('SeaExport.CustomsDeclared')" :value="4" />
          <el-option :label="$t('SeaExport.Undeclared')" :value="5" />
          <el-option :label="$t('SeaExport.CustomsExamination')" :value="6" />
          <el-option :label="$t('SeaExport.InspectionExamination')" :value="7" />
          <el-option :label="$t('SeaExport.ExamedWithoutReleasing')" :value="8" />
          <el-option :label="$t('SeaExport.AmendDeclaration')" :value="9" />
          <el-option :label="$t('SeaExport.NotifyToDeclare')" :value="10" />
          <el-option :label="$t('SeaExport.CustomsHasCheck')" :value="11" />
          <el-option :label="$t('SeaExport.CustomsExamed')" :value="12" />
          <el-option :label="$t('SeaExport.CustomsOneRelease')" :value="13" />
          <el-option :label="$t('SeaExport.CustomsRelease2')" :value="14" />
          <!--          <el-option :label="$t('SeaExport.hasBeanSend')" :value="15" />
          <el-option :label="$t('SeaExport.notSend')" :value="16" />
          <el-option :label="$t('SeaExport.UnknownState')" :value="17" />-->
        </el-select>
      </el-form-item>
      <el-form-item v-show="closeXhqCustoms" class="custom">
        <el-checkbox v-model="oneFormData.commodityInspection" no="10">{{ $t('SeaExport.CommodityInspectionOrNot') }}</el-checkbox>
        <el-checkbox v-model="oneFormData.spotInspection" no="11">{{ $t('SeaExport.CustomsInspectionOrNot') }}</el-checkbox>
      </el-form-item>
      <el-form-item v-show="closeXhqCustoms" :label="$t('SeaExport.CustomsDeclarationType')">
        <el-select
          :value="oneFormData.declareCustomsType||''"
          :placeholder="$t('common.tips.pleaseChoose')"
          no="12"
          @input="value=>{oneFormData.declareCustomsType=value}"
        >
          <el-option
            v-for="(item,index) in customsDeclarationTypes"
            :key="index"
            :label="item.chineseName"
            :value="item.code"
          />
        </el-select>
      </el-form-item>
      <el-form-item v-show="closeXhqCustoms" :label="$t('SeaExport.PreNumber')">
        <el-input v-model="oneFormData.preNumber" no="13" />
      </el-form-item>
      <el-form-item v-show="closeXhqCustoms" :label="$t('SeaExport.PlateNumber')">
        <el-input v-model="oneFormData.plateNumber" no="14" />
      </el-form-item>
      <el-form-item v-show="closeXhqCustoms" :label="$t('SeaExport.ContainerNo2')">
        <el-input v-model="oneFormData.containerNo" no="15" />
      </el-form-item>
      <div style="display: flex">
        <el-form-item v-show="closeXhqCustoms" :label="$t('SeaExport.Quantity2')">
          <auto-number-input v-model="oneFormData.quantity" :precision="2" no="quantity" />
        </el-form-item>
        <el-form-item v-show="closeXhqCustoms" :label="$t('SeaExport.itemCount')">
          <auto-number-input v-model="oneFormData.number" :precision="2" no="number" />
        </el-form-item>
      </div>
      <div style="display: flex">
        <el-form-item v-show="closeXhqCustoms" :label="$t('SeaExport.Weight')">
          <auto-number-input v-model="oneFormData.weight" :precision="3" no="weight" />
        </el-form-item>
        <el-form-item v-show="closeXhqCustoms" :label="$t('SeaExport.ExchangeRate')">
          <auto-number-input v-model="oneFormData.rate" :precision="2" no="rate" />
        </el-form-item>
      </div>
      <div style="display: flex">
        <el-form-item v-show="closeXhqCustoms" :label="$t('CargoMsg.Cargo_SystemFee')">
          <auto-number-input v-model="oneFormData.systemFee" :precision="2" no="systemFee" />
        </el-form-item>
        <el-form-item v-show="closeXhqCustoms" :label="$t('CargoMsg.Cargo_InsurancePremium')">
          <auto-number-input v-model="oneFormData.insurancePremium" :precision="2" no="insurancePremium" />
        </el-form-item>
      </div>
      <div style="display: flex">
        <el-form-item v-show="closeXhqCustoms" :label="$t('CargoMsg.Cargo_ProcessingFee')">
          <auto-number-input v-model="oneFormData.processingFee" :precision="2" no="processingFee" />
        </el-form-item>
        <el-form-item v-show="closeXhqCustoms" :label="$t('CargoMsg.Cargo_FOBValue')">
          <auto-number-input v-model="oneFormData.freeOnBoard" :precision="2" no="freeOnBoard" />
        </el-form-item>
      </div>
      <el-form-item :label="$t('SeaExport.Remarks')">
        <el-input v-model="oneFormData.remarks" type="textarea" :rows="3" no="16" />
      </el-form-item>
      <el-form-item v-show="openXhqCustomsAll" :label="$t('CargoMsg.PushOrNot')">
        <el-select v-model="oneFormData.pushOrNot" no="pushOrNot" style="width:150px">
          <el-option label="Y" :value="true" />
          <el-option label="N" :value="false" />
        </el-select>
      </el-form-item>
      <el-form-item v-show="(!closeXhqCustoms && oneFormData.xhqCustomState !== XhqCustomState.SENT.code && oneFormData.xhqCustomState !== XhqCustomState.SENT_LCL_TASK.code)" :label="$t('SeaExport.CustomsInformation')">
        <el-button type="primary" no="17" @click="toQuery">{{ $t('FileHistory.Refresh') }}</el-button>
        <el-button type="primary" style="margin-left: 10px" no="18" @click="shouCloudUpload">{{ $t('SeaExport.AddFile') }}</el-button>
        <el-button type="danger" style="margin-left: 10px" no="19" @click="remove">{{ $t('FileHistory.Delete') }}</el-button>
      </el-form-item>
      <el-form-item v-show="openXhqCustomsAll && (oneFormData.xhqCustomState === XhqCustomState.SENT.code || oneFormData.xhqCustomState === XhqCustomState.SENT_LCL_TASK.code)" :label="$t('SeaExport.CustomsInformation')">
        <el-button no="toXhqRecallCustomsFiles" type="danger" @click="toXhqRecallCustomsFiles">{{ $t('Message.Withdraw') }}</el-button>
      </el-form-item>
      <span v-show="!closeXhqCustoms" style="margin-left: 10px;color: red">{{ $t('Message.ReminderOfTheCustomsData') }}</span>
      <el-form-item v-show="!closeXhqCustoms" class="custom" style="margin-top: 5px" label-width="0">
        <div style="height: 200px">
          <cargo-ag-grid
            :show-side-bar="false"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            style="width:100%;height:180px"
            @gridReady="params=>gridApi=params.api"
          />
        </div>
      </el-form-item>
      <span v-show="!closeXhqCustoms" style="margin-left: 10px;color: red">{{ $t('Message.ReminderOfTheCustomsPrint') }}</span>
      <br v-show="!closeXhqCustoms">
      <el-button v-show="!closeXhqCustoms && !slaveCustomsDeclarationEnable" type="text" no="ObtainActualData" @click="getActualData">{{ $t('Message.ObtainActualBusinessData') }}</el-button>
      <!--开启【信号旗】但是未开启【关单多票模式】-->
      <div v-show="!closeXhqCustoms && !slaveCustomsDeclarationEnable" style="margin-bottom: 10px;margin-left: 8px">
        <label style="margin-right: 4px">{{ $t('SeaExport.Quantity') }}</label>
        <el-input v-model="oneFormData.quantityActual" type="number" no="quantityActual" style="width: 80px" />
        <label style="margin-left: 10px;margin-right: 4px">{{ $t('SeaExport.WeightKg') }}</label>
        <el-input v-model="oneFormData.weightActual" type="number" no="weightActual" style="width: 80px" />
        <label style="margin-left: 10px;margin-right: 4px">{{ $t('SeaExport.CubageCbm') }}</label>
        <el-input v-model="oneFormData.cubageActual" type="number" no="cubageActual" style="width: 80px" />
      </div>
    </el-form>
    <cargo-cloud-file-upload
      :visible.sync="cloudFile.visible"
      :job="cloudFile.job"
      :lob="cloudFile.lob"
      :from-lob="cloudFile.fromLob"
      :file-size="cloudFile.fileSize"
      :upload-files="cloudFile.uploadFiles"
      :show-drop="job.lob === 'SE'"
      :other-param="otherParam"
      @uploadDone="updateSop"
    />
    <div slot="footer">
      <el-button type="primary" no="20" @click="enterHandler">{{ $t('SeaExport.Confirm') }}</el-button>
      <el-button v-show="openXhqCustomsAll && isEdit && !openMeiHuaCustom" no="xhqSendHandler" type="primary" @click="sendHandler">{{ $t('SeaExport.Send') }}</el-button>
      <el-button no="21" @click="innerVisible=false">{{ $t('common.btn.cancel') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>

import { cacheName, cache } from '@/utils/cacheManager'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import {
  customsSave,
  xhqQueryCustomsFilesSendState,
  xhqSendCustomsFiles,
  xhqRecallCustomsFiles,
  getSoNos,
  deleteFileByUuid
} from '@/api/seaExport/customsInfo'
import { getBusinessByCompany, getBusinessByTenDigitCode, businessCheckSaveUpdate } from '@/api/seaExport/file'
import { CustomsInfo } from '@/class/model/booking/CustomsInfo'
import * as SEConst from '@/class/cargo/model/parameters/SeaExportConstants'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import StrUtils from '@/utils/StrUtils'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import { getLoading } from '@/utils/utilBaseElement'
import { deleteFile, getFileList } from '@/api/storage'
import cargoCloudFileUpload from '@/components/Cargo/Common/cargoCloudFileUpload.vue'
import { DocumentManage } from '@/utils/commonUtil'
import { sortByMultiField } from '@/utils'
import * as XhqCustomState from '@/class/cargo/model/parameters/XhqCustomState'
import moment from 'moment'
import * as ContainerLoadType from '@/class/cargo/model/parameters/ContainerLoadType'
import URL from '@/api/urlTranslator'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput'
import { AirImportJob } from '@/class/model/booking/AirImportJob'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { poItems } from '@/api/seaExport/poItems'

export default {
  name: 'CustomsInfoDialog',
  components: { cargoCloudFileUpload, AutoNumberInput, cargoAdvanceSelect, cargoCompanySelect },
  props: {
    visible: { type: Boolean, required: true },
    job: {
      type: Object,
      required: true
    },
    selectedCustomsInfo: {
      type: Object,
      required: true
    },
    isCustomInfo: {
      type: Boolean,
      required: false,
      default: false
    },
    slaveCustomsDeclarationEnable: { // 海出【小票】关单信息 是否可用
      type: Boolean,
      default: false
    },
    customsInfos: { type: Array, default: () => [] },
    isSalesForSzfs: { type: Boolean, default: false } // 深圳丰收销售专用
  },
  data() {
    return {
      isNew: false,
      isEdit: false,
      isExport: false,
      isQuerying: false,
      selectTypeNames: TYPE_NAMES,
      innerVisible: false,
      customsDeclarationTypes: [...SEConst.DECLARE_CUSTOMS_TYPES],
      business: {},
      soNoList: [],
      bussinessList: [],
      currentUser: {},
      oneFormData: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        }
      },
      columnDefs: [
        {
          headerName: '', width: 60, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        }, {
          headerName: this.$t('SeaExport.FileType'),
          field: 'fileType',
          width: 100,
          cellRenderer: params => {
            return (params.value || '').toUpperCase()
          }
        }, {
          headerName: this.$t('CargoMsg.Cargo_FileName'),
          field: 'fileName',
          width: 140
        }, {
          headerName: this.$t('Partners.UploadTime'),
          field: 'createDate',
          width: 140
        }, {
          headerName: this.$t('FileHistory.view'),
          field: 'fileId',
          width: 100,
          cellRenderer: params => {
            const methodOnFileViewPath = this.documentManage.getPath('onFileView')
            return `<a onclick="${methodOnFileViewPath}('${params.value}')" style="color:#46a6ff">${this.$t('FileHistory.view')}</a>`
          }
        }
      ],
      gridApi: null,
      rowData: [],
      cloudFile: {
        visible: false,
        job: {
          lob: 'SE'
        },
        lob: 'SE',
        fromLob: '',
        fileSize: 20480000
      },
      documentManage: new DocumentManage(),
      docType: [],
      xinHaoQiApi: 0,
      openMeiHuaCustom: 0,
      otherParam: {
        customsInfoUuid: ''
      },
      poItems: [] // 关单号下拉列表
    }
  },
  computed: {
    XhqCustomState() {
      return XhqCustomState
    },
    closeXhqCustoms() { // 关闭信号旗报关参数
      return this.xinHaoQiApi === 0 && this.openMeiHuaCustom === 0
    },
    openXhqCustoms() { // 信号旗参数等于1，仅接收文件
      return this.xinHaoQiApi === 1
    },
    openXhqCustomsAll() { // 信号旗参数等于2，推送信号旗报关单，同时接收回传文件 (完整模式)
      return this.xinHaoQiApi === 2
    },
    soNoFromCustomsDeclaration() {
      return this.xinHaoQiApi !== 0 && this.slaveCustomsDeclarationEnable
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      if (!newVal) {
        // this.rowData = []
      }
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
    }
  },
  beforeMount() {
    const context = this
    this.documentManage.set('popFileHistoryDetailFormDialog', function(value) {
      context.popFileHistoryDetailFormDialog(value)
    })
    this.documentManage.set('onFileView', function(value) {
      context.onFileView(value)
    })
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    async onShow(action, customs = []) {
      await cache.load(cacheName.USER, cacheName.CONFIG)
      this.currentUser = cache.user
      this.configMap = cache.config
      this.xinHaoQiApi = Number(this.configMap.get('xinHaoQiApi'))
      this.openMeiHuaCustom = Number(this.configMap.get('openMeiHuaCustom'))
      if (this.soNoFromCustomsDeclaration) {
        await this.refreshPoItemsDownList(action)
      }
      if (action === 'add') {
        this.addCustInfoHandler(customs)
      } else if (action === 'edit') {
        this.editCustInfoHandler()
      }
      this.rowData = []
      if (this.xinHaoQiApi || this.openMeiHuaCustom) {
        this.showXhqModelView(customs)
      } else {
        this.showModelView()
      }
      await this.initData()
    },
    async refreshPoItemsDownList(action) {
      this.poItems = []
      await new SeaExportJob(this.job).getPoItems()
      if (this.job.poItems && this.job.poItems.length > 0) {
        if (this.customsInfos && this.customsInfos.length > 0) {
          const excludePoItemsUuids = new Set()
          for (const customsInfo of this.customsInfos) {
            if (customsInfo.poItemsUuid) {
              excludePoItemsUuids.add(customsInfo.poItemsUuid)
            }
          }
          this.poItems = this.job.poItems.filter(poItem => (action === 'edit' && this.selectedCustomsInfo.poItemsUuid === poItem.uuid) || !excludePoItemsUuids.has(poItem.uuid))
        } else {
          this.poItems = this.job.poItems
        }
      }
    },
    // 初始化shi
    async initData() {
      this.bussinessList = []
      await getBusinessByCompany('%', true).then(res => {
        if (res.data) {
          for (const item of res.data) {
            if (item.companyCname && item.companyCname.trim().length > 0) {
              this.bussinessList.push(item)
            }
          }
        }
      })
    },
    addCustInfoHandler(customs) {
      this.oneFormData = new CustomsInfo().fillDefaultValue().getData()
      // 新增时，如果一票基本页签只有一个关单号，则自动带出当前那条数据。
      if (this.soNoFromCustomsDeclaration) {
        if (this.job.poItems && this.poItems.length === 1) {
          this.oneFormData.poItemsUuid = this.poItems[0].uuid
          this.poItemsUuidChangeHandler()
        }
      }
      this.oneFormData.mbl = this.job.mbl
      if (!this.isCustomInfo) {
        this.oneFormData.customsDate = new Date()
      }
      this.oneFormData.jobUuid = this.job.uuid
      this.oneFormData.customsBroker = this.job.customsBroker
      this.oneFormData.declareCustomsType = ''
      this.isNew = true
      this.oneFormData.lob = this.job.lob
      if (this.job.lob === 'AE') {
        this.oneFormData.declareCustomsState = 0
      }
      if (this.job.containerLoadType === ContainerLoadType.LCL_CARGO_TYPE.code ||
        this.job.containerLoadType === ContainerLoadType.BB_CARGO_TYPE.code ||
        this.job.containerLoadType === ContainerLoadType.BC_CARGO_TYPE.code) {
        this.oneFormData.verificationSheetRequired = false
      } else {
        this.oneFormData.verificationSheetRequired = true
      }
      this.oneFormData.xhqCustomState = XhqCustomState.NOT_SENT.code
      if (this.closeXhqCustoms) {
        this.oneFormData.soNo = this.job.soNo
      } else {
        this.oneFormData.noticeBgh = true
        if (this.job.etd) {
          this.oneFormData.declareTime = moment(this.job.etd).endOf('day').format('YYYY-MM-DD HH:mm:ss')
        }
        // 开启信号旗参数时
        if (!customs || customs.length === 0) {
          this.oneFormData.cbaNumber = this.job.jobNo
        } else if (customs.length === 1) {
          this.oneFormData.cbaNumber = this.job.jobNo + '-02'
        } else {
          let max = 2
          for (const custom of customs) {
            if (custom.cbaNumber.includes('-')) {
              const current = Number(custom.cbaNumber.split('-')[1])
              if (current > max) {
                max = current
              }
            }
          }
          max += 1
          if ((max + '').length === 1) {
            this.oneFormData.cbaNumber = this.job.jobNo + '-0' + max
          } else {
            this.oneFormData.cbaNumber = this.job.jobNo + '-' + max
          }
        }
      }
    },
    async editCustInfoHandler() {
      this.oneFormData = { ...new CustomsInfo(this.selectedCustomsInfo).getData() }
      delete this.oneFormData.businessDocuments
      if (StrUtils.isEmpty(this.oneFormData.declareCustomsType)) {
        this.oneFormData.declareCustomsType = 0
      }
      this.isNew = false
      this.isEdit = true
    },
    showModelView() {
      this.soNoList = []
      this.isExport = this.job.lob === 'SE' || this.job.lob === 'AE'
      if (this.job.lob === 'SE') {
        const soNo = this.job.soNo
        if (soNo != null && soNo !== '') {
          const soNoArray = soNo.split('\n')
          for (const value of soNoArray) {
            this.soNoList.push(value)
          }
        }
      } else {
        if (!StrUtils.isEmpty(this.job.mbl)) {
          this.soNoList.push(this.job.mbl)
        }
      }
      getSoNos({ jobUuid: this.job.uuid }).then(res => {
        if (res.data) {
          for (const item of res.data) {
            if (item && item.trim().length > 0) {
              if (!this.soNoList.includes(item)) {
                this.soNoList.push(item)
              }
            }
          }
        }
      })
      if (this.isNew) {
        this.oneFormData.soNo = this.soNoList.length > 0 ? this.soNoList[0] : null
      }

      if (!StrUtils.isEmpty(this.oneFormData.soNo) && !this.soNoList.includes(this.oneFormData.soNo)) {
        this.soNoList.push(this.oneFormData.soNo)
      }
      // width = _isExport ? 456 : 380;
      this.toQuery()
    },
    showXhqModelView(customs) {
      this.soNoList = []
      const soNoList = []
      this.isExport = this.job.lob === 'SE' || this.job.lob === 'AE'
      if (this.job.lob === 'SE') {
        const soNo = this.job.soNo
        if (soNo != null && soNo !== '') {
          const soNoArray = soNo.split('\n')
          for (const value of soNoArray) {
            soNoList.push(value)
          }
        }
      }
      if (!StrUtils.isEmpty(this.job.mbl)) {
        soNoList.push(this.job.mbl)
      }
      getSoNos({ jobUuid: this.job.uuid }).then(res => {
        if (res.data) {
          for (const item of res.data) {
            if (item && item.trim().length > 0) {
              if (!soNoList.includes(item)) {
                soNoList.push(item)
              }
            }
          }
        }
      })
      if (!StrUtils.isEmpty(this.oneFormData.soNo) && !soNoList.includes(this.oneFormData.soNo)) {
        soNoList.push(this.oneFormData.soNo)
      }
      for (const item of soNoList) {
        let exist = false
        for (const custom of customs) {
          if (item === custom.soNo) {
            exist = true
            break
          }
        }
        if (!exist && !this.soNoList.includes(item)) {
          this.soNoList.push(item)
        }
      }
      if (this.isNew) {
        let soNo
        if (this.job.containerLoadType === ContainerLoadType.FCL_CARGO_TYPE.code && this.job.mbl && !this.job.soNo) {
          soNo = this.job.mbl
        } else if ((this.job.containerLoadType === ContainerLoadType.LCL_CARGO_TYPE.code || this.job.containerLoadType === ContainerLoadType.BB_CARGO_TYPE.code ||
          this.job.containerLoadType === ContainerLoadType.BC_CARGO_TYPE.code || this.job.containerLoadType === ContainerLoadType.BC_CARGO_TYPE_FCL.code) &&
          this.job.soNo && !this.job.soNo.includes('\n')) {
          soNo = this.job.soNo
        }
        if (soNo && this.soNoList.includes(soNo)) {
          this.oneFormData.soNo = soNo
        }
      } else {
        if (this.oneFormData.soNo) {
          this.soNoList.push(this.oneFormData.soNo)
        }
      }
      this.toQuery()
    },
    async enterHandler() {
      const soNoNotEmpty = parseInt(cache.config.get('SoNoNotEmpty')) === 1
      if (!soNoNotEmpty && this.oneFormData.soNo === '' && (this.job.preverifyState === 2 || this.job.jobState === SystemConstants.STATE_OPERATING.code)) {
        this.$message.warning(this.$t('Message.SoNoCannotBeNull'))
        return
      }
      if (!this.closeXhqCustoms) {
        await this.xhqSaveCustomsInfo()
      } else {
        await this.saveFile()
      }
      this.refreshPoItems()
    },
    async refreshPoItems() {
      // 刷新【关单信息】中【报关信息】
      if (this.soNoFromCustomsDeclaration) {
        this.job.poItems = await poItems({ jobUuid: this.job.uuid }).then(res => res.data)
      }
    },
    async saveFile() {
      if (this.oneFormData == null) { return }
      const loading = getLoading()
      await customsSave(this.oneFormData).then(res => {
        this.businessSaveOrUpdate()
        this.$emit('successHandler', res.data)
        this.innerVisible = false
      }).finally(() => {
        loading.close()
      })
    },
    async xhqSaveCustomsInfo() {
      if (this.oneFormData == null) { return }
      const loading = getLoading()
      await customsSave(this.oneFormData).then(res => {
        this.$emit('successHandler', res.data)
        this.innerVisible = false
      }).finally(() => {
        loading.close()
      })
    },
    async sendHandler() {
      if (!this.rowData || !(this.rowData.length > 0)) {
        this.$message.warning(this.$t('CargoMsg.AddCustomerFileFirst'))
      }
      this.oneFormData.fileIds = Array.from(this.rowData, p => p.fileId).reduce((a, b) => a + ',' + b)
      if (!this.oneFormData.declareTime) {
        this.$message.warning(this.$t('CargoMsg.FilledMustFill', [this.$t('CargoMsg.CustomsDeclareTime')]))
        return
      }
      if (!this.oneFormData.customsBroker) {
        this.$message.warning(this.$t('CargoMsg.FilledMustFill', [this.$t('SeaExport.CustomsBroker')]))
        return
      }
      if (!this.oneFormData.fileIds || !(this.oneFormData.fileIds.length > 0)) {
        this.$message.warning(this.$t('CargoMsg.FilledMustFill', [this.$t('SeaExport.CustomsFile')]))
        return
      }
      if (this.soNoFromCustomsDeclaration && !this.oneFormData.poItemsUuid) {
        this.$message.warning(this.$t('CargoMsg.FilledMustFill', [this.$t('SeaExport.SoNo')]))
        return
      }
      // 编辑之后直接发送，需要先保存一下报关单再发送
      const loading = getLoading()
      await customsSave(this.oneFormData).then(res => {
        this.$emit('successHandler', res.data)
        this.innerVisible = false
      })
      xhqSendCustomsFiles(this.oneFormData).then(res => {
        if (res.data) {
          this.$message.warning(res.data)
        } else {
          this.$message.success(this.$t('SeaExport.SendSucceeded'))
        }
        this.$emit('loadList')
        this.innerVisible = false
      }).finally(() => {
        loading.close()
      })
    },
    tenDigitCodeChangeHandler(value) {
      this.oneFormData.tenDigitCode = value
      if (this.oneFormData.tenDigitCode && this.oneFormData.tenDigitCode.trim().length > 10) {
        this.oneFormData.tenDigitCode = this.oneFormData.tenDigitCode.trim().substr(0, 10)
      }
      if (this.oneFormData.tenDigitCode.length === 10) {
        this.isQuerying = true
        getBusinessByTenDigitCode(this.oneFormData.tenDigitCode).then(res => this.resultHandler(res.data))
      }
    },
    tenDigitCodeFocusOutHandler() {
      const elSelect = this.$refs.tenDigitCode
      const innerInput = elSelect.$children[0].$refs.input
      if (innerInput.value) {
        this.oneFormData.tenDigitCode = innerInput.value
      }
    },
    queryBusinessHandler(value) {
      this.oneFormData.companyCname = value
      if (this.oneFormData.companyCname && this.oneFormData.tenDigitCode.length !== 10) {
        this.isQuerying = true
        getBusinessByCompany(this.oneFormData.companyCname, false).then(res => this.resultHandler(res.data))
      }

      this.isQuerying = true
    },
    companyCnameFocusOutHandler() {
      const elSelect = this.$refs.companyCname
      const innerInput = elSelect.$children[0].$refs.input
      if (innerInput.value) {
        this.oneFormData.companyCname = innerInput.value
      }
    },
    resultHandler(data) {
      this.isQuerying = false
      if (data && data.length > 0) {
        this.business = data[0]
        this.oneFormData.tenDigitCode = this.business.tenDigitCode
        this.oneFormData.companyCname = this.business.companyCname
      } else {
        this.business = null
      }
    },
    // 报关 保存后 保存或者更新 海关十字码
    businessSaveOrUpdate() {
      if (this.oneFormData.tenDigitCode.length !== 10) { return }

      if (!this.business || this.business.tenDigitCode !== this.oneFormData.tenDigitCode || this.business.companyCName !== this.oneFormData.companyCname) {
        // 公司名字被更新过
        const params = {
          tenDigitCode: this.oneFormData.tenDigitCode,
          companyCName: this.oneFormData.companyCname
        }
        businessCheckSaveUpdate(params)
      }
    },
    // 查询文件
    async toQuery() {
      if (!this.oneFormData || !this.oneFormData.uuid) {
        return
      }
      this.storageURL = this.configMap.get('StorageURL')
      const xmlParam = '<RequestObject><data><extendMetaData><entry><key>uuid</key><value>' +
        this.oneFormData.uuid +
        '</value></entry></extendMetaData></data></RequestObject>'
      await getFileList(xmlParam).then(res => {
        const files = Array.from(res.data, p => {
          return {
            fileId: p.id,
            fileName: p.fileName,
            fileType: p.extendMetaData.documentType || '',
            fileFormat: p.fileType.split(';')[0],
            fileSize: p.fileSize,
            fileVersion: p.fileVersion || '',
            createDate: p.createDate,
            createChineseName: p.extendMetaData.createChineseName || '',
            createdBy: p.extendMetaData.createdBy,
            extendMetaData: p.extendMetaData,
            fileNameBak: p.fileName,
            path: '',
            hasParent: false,
            parentId: ''
          }
        })
        this.rowData = files
      })
      this.getFilesSucceedHandler()
    },
    // 打开附件上传公共弹窗
    shouCloudUpload() {
      if (this.oneFormData.uuid === undefined || this.oneFormData.uuid === null || this.oneFormData.uuid === '') {
        this.$message.warning(this.$t('Message.CheckCustomsSaved'))
        return
      }
      this.cloudFile.lob = this.job.lob
      this.cloudFile.fromLob = 'XHQ'
      this.cloudFile.job.lob = this.job.lob
      this.cloudFile.job.uuid = encodeURIComponent(this.oneFormData.uuid)
      this.cloudFile.uploadFiles = this.rowData
      this.cloudFile.visible = true
      this.otherParam.customsInfoUuid = this.oneFormData.uuid
    },
    /* 文件列表 父级和子级组装*/
    getFilesSucceedHandler: function() {
      this.rowData = sortByMultiField(this.rowData, ['fileName', 'fileVersion', 'createDate'], true)
      if (!this.rowData || this.rowData.length === 0) {
        return
      }
      let fatherFile = this.rowData[0]
      // 初始化 首个父节点的path
      fatherFile.path = fatherFile.fileId
      const source = []
      source.push(fatherFile)
      let childFile
      for (let i = 1; i < this.rowData.length; i++) {
        childFile = this.rowData[i]
        if (childFile.fileName === fatherFile.fileName) {
          if (fatherFile.hasParent) {
            childFile.path = fatherFile.parentId + ',' + childFile.fileId
          } else {
            childFile.path = fatherFile.fileId + ',' + childFile.fileId
            childFile.hasParent = true
            childFile.parentId = fatherFile.fileId
          }
          // childFile.fileName = ''
        } else {
          // 遍历到父节点了
          childFile.path = childFile.fileId
        }
        source.push(childFile)
        fatherFile = childFile
      }
      this.rowData = source
    },
    // 删除文件
    remove() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      const self = this
      this.$confirm(this.$t('SeaExport.DeleteNumFile').replace('{0}', rows.length), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'info'
      }).then(async() => {
        try {
          for (const item of rows) {
            const isSuccess = await deleteFileByUuid({ customsInfoUuid: this.oneFormData.uuid, fileId: item.fileId }).then(res => res.data === 'success')
            if (isSuccess) {
              item.isDeleted = true
            } else {
              break
            }
          }
        } finally {
          self.toQuery()
        }
      }).catch(() => {
      })
    },
    // 上传成功回掉
    async updateSop(documentTypeUuid) {
      console.log(documentTypeUuid)
      this.toQuery()
    },
    // 查看文件
    onFileView(value) {
      const fileObject = this.rowData.find(x => x.fileId === value)
      // 测试 编辑保存
      // this.itemEditEndHandler(fileObject)

      // 判断是否有下载文件的权限
      if (!this.$checkPermission(['button_FileHistory_fileDownloads'])) {
        if (!this.checkDownloadFile(fileObject)) {
          return
        }
      }
      // 检查文件查询权限
      if (fileObject.extendMetaData.hasOwnProperty('documentType')) {
        if (!this.checkFileDocTypeRole(fileObject)) {
          return
        }
      }
      const url = `${URL.common.findByFileId}/${value}?sessionId=${this.currentUser.sessionId}`
      window.open(url)
    },
    checkDownloadFile(data) {
      if (Number(data.createdBy) !== this.currentUser.userId) {
        this.$message.warning(this.$t('SeaExport.NoPermissionToViewOrprinted'))
        return false
      }
      return true
    },
    checkFileDocTypeRole(data) {
      let documentType = data.extendMetaData.documentType
      if (documentType === this.$t('Message.Other')) {
        documentType = 'OTHER'
      }
      if (documentType === 'other' || documentType === 'Other') {
        documentType = documentType.toLocaleUpperCase()
      }
      const result = this.getDocType(documentType)
      if (result === null || result.length === 0) {
        return true
      }

      if (this.currentUser.admin || parseInt(data.createdBy) === this.currentUser.userId) {
        return true
      }

      const fileRoleMap = this.getFileRoleMap(result)
      if (fileRoleMap.length === 0) {
        this.$message.info(`[${data.fileName}]${this.$t('Message.TheToBeViewedAnyone')}`)
        return false
      }
      let isView = false
      if (this.$checkPermission(['role_sales']) && fileRoleMap.indexOf('sales') !== -1) {
        isView = true
      }
      if (this.$checkPermission(['role_op']) && fileRoleMap.indexOf('op') !== -1) {
        isView = true
      }
      if (!isView && fileRoleMap.indexOf('all') !== -1) {
        isView = true
      }
      if (!isView) {
        this.$message.info(`${this.$t('Message.YouPermissionToViewDownload')}[${data.fileName}]${this.$t('Message.File')}`)
        return false
      }
      return true
    },
    // 获取code所关联的XML 原cargo getDocTypeXml
    getDocType(codes) {
      const docTypeFilter = []
      if (codes == null || codes === '') {
        return null
      }
      var codeArray = codes.split(',')
      for (let i = 0; i < codeArray.length; i++) {
        var docObject = this.docType.find(x => x.code === codeArray[i])
        if (docObject != null) {
          docTypeFilter.push(docObject)
        }
      }
      return docTypeFilter
    },
    //  文档属性权限
    getFileRoleMap(result) {
      const fileRoleMap = []
      if (this.getDocTypeRole('sales', result)) {
        fileRoleMap.push('sales')
      }
      if (this.getDocTypeRole('op', result)) {
        fileRoleMap.push('op')
      }
      if (this.getDocTypeRole('all', result)) {
        fileRoleMap.push('all')
      }
      return fileRoleMap
    },
    // 获取 获取属性访问权限
    getDocTypeRole(roleKey, docType) {
      if (docType === null || docType.length === 0) {
        return false
      }
      if (roleKey === 'all') {
        roleKey = 'other'
      }
      for (var i = 0; i < docType.length; i++) {
        if (docType[i][roleKey]) {
          return true
        }
      }

      return false
    },
    toXhqRecallCustomsFiles() {
      const loading = getLoading()
      const params = {
        customsInfoUuid: this.oneFormData.uuid,
        orderOutNo: this.oneFormData.cbaNumber,
        opOffice: this.job.opOffice
      }
      xhqRecallCustomsFiles(params).then(res => {
        if (res.data) {
          this.$message.warning(res.data)
        } else {
          this.$message.success(this.$t('CargoMsg.Cargo_AlreadyWithdraw'))
        }
        this.$emit('loadList')
        this.innerVisible = false
      }).finally(() => {
        loading.close()
      })
    },
    // 获取基本页签实际件毛体
    getActualData() {
      this.oneFormData.quantityActual = this.job.quantityActual
      this.oneFormData.weightActual = this.job.weightActual
      this.oneFormData.cubageActual = this.job.cubageActual
    },
    poItemsUuidChangeHandler() {
      if (!this.oneFormData.poItemsUuid) {
        this.oneFormData.soNo = ''
        this.oneFormData.quantityActual = 0
        this.oneFormData.weightActual = 0
        this.oneFormData.cubageActual = 0
      } else {
        const poItem = this.poItems.find(p => p.uuid === this.oneFormData.poItemsUuid)
        this.oneFormData.soNo = poItem.soNo
        this.oneFormData.quantityActual = poItem.quantity
        this.oneFormData.weightActual = poItem.grossWeight
        this.oneFormData.cubageActual = poItem.cubage
      }
    }
  }
}
</script>

<style>
</style>
